export const BANNER_HEIGHT = 352;
